import {Directive, ElementRef, EventEmitter, OnDestroy, AfterViewInit, Output} from '@angular/core';
import {ClickService} from '@core/services/click.service';
import {Subscription} from 'rxjs';

/**
 * Emits when a click occurs outside the host element.
 * Uses ClickService for consistent click handling across the app.
 * Preferred over ClickOutsideDirective for components with CDK overlays.
 */
@Directive({
  selector: '[motnClickOutsideService]',
  standalone: true,
})
export class ClickOutsideServiceDirective implements AfterViewInit, OnDestroy {
  @Output() motnClickOutsideService = new EventEmitter<void>();

  private clickSub?: Subscription;

  constructor(
    private elementRef: ElementRef,
    private clickService: ClickService,
  ) {}

  ngAfterViewInit(): void {
    this.clickSub = this.clickService.click$.subscribe(
      ($el) => {
        if (!this.elementRef.nativeElement.contains($el)) {
          this.motnClickOutsideService.emit();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.clickSub?.unsubscribe();
  }
}
